import React, { useState, useEffect, useRef } from "react";
import styles from "./CciAppsUseCov.module.css";
import { Row, Col, Card, Tooltip, Space, Spin, Select, message } from 'antd';
import { fetchJsData } from "../../../../api";
import { Bar } from "react-chartjs-2";
import "chartjs-plugin-datalabels";
const { Option } = Select;

const dateLable = [
  "Dec 19",
  "Jan 20",
  "Feb 20",
  "Mar 20",
  "Apr 20",
  "May 20",
  "Jun 20",
  "Jul 20",
  "Aug 20",
  "Sep 20",
  "Oct 20",
  "Nov 20",
];

const monthlyDataLabel = {
  0: {
    label: "Discovery only Apps",
    extra: "Not eligible for CCI score",
    color: "green",
  },
  1: {
    label: "Unused Apps in last 6 months",
    extra: "Including both active and inactive Apps",
    color: "blue",
  },
  2: {
    label: "Inactive Apps",
    extra: "Associate domains are not reachable",
    color: "orange",
  },
  3: {
    label: "Unused inactive Apps",
    extra: "Inactive Apps not used in last 3 months",
    color: "red",
  },
};
const CciAppsUseCov = () => {
  const [trendData, setTrendData] = useState({
    labelDt: dateLable,
    cciUseCov: {},
    labelMonData: dateLable,
    monthlyData: {},
  });
  const [trendLoad, setTrendLoading] = useState(true);
  const [chngLoad, setChngLoading] = useState(true);
  const [limiter, setLimiter] = useState(12);
  const [submit, setSubmit] = useState(true);

  useEffect(() => {
    console.log("effect");
    fetchData();
  }, [submit]);

  const fetchData = async () => {
    setTrendLoading(true);
    const cciUseCovFetch = await fetchJsData({
      type: "fetch",
      qry: "fetCciUseCov",
      preProcess: true,
      preProcFunc: "fetCciUseCov",
      firstVal: limiter,
    });
    const cciMonData = await fetchJsData({
      type: "fetch",
      qry: "fetMonthlyData",
      preProcess: true,
      preProcFunc: "fetMonthlyData",
      firstVal: limiter,
    });
    setTrendData({
      labelDt: cciUseCovFetch?.data?.labelmonths,
      cciUseCov: cciUseCovFetch?.data?.graphData,
      labelMonData: cciMonData?.data?.labelmonths,
      monthlyData: cciMonData?.data?.graphData,
    });
    console.log("web", trendData);
    setTrendLoading(false);
    setChngLoading(!chngLoad);
  };

  function onChange(value) {
    if (value == "100") {
      message.info(`All Months Selected`);
    } else {
      message.info(`${value} Months Selected`);
    }
    setLimiter(parseInt(value));
    setSubmit(!submit);
  }
  return (
    <>
      <div
        ref={refTool}
        style={{
          backgroundColor: "rgba(27,31,35,.05)",
          opacity: 0.9,
          color: "black",
          position: "absolute",
          borderRadius: "5%",
          zIndex: 1000,
          padding: "5px",
        }}
      ></div>
      <Row type="flex" style={{ margin: "5px", padding: "1px" }}>
        <Col className="gutter-row" span={1}></Col>
        <Col className="gutter-row" span={14}>
          <Card
            bordered={false}
            style={{ height: 70, margin: "1px", padding: "1px" }}
          >
            <Tooltip title="Month Filter">
              <Space>
                <Select
                  showSearch
                  defaultValue={"last " + limiter + " Months"}
                  style={{ width: 400 }}
                  placeholder="Month Filter"
                  optionFilterProp="children"
                  onChange={onChange}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value="6">last 6 Months</Option>
                  <Option value="12">last 12 Months</Option>
                  <Option value="24">last 24 Months</Option>
                  <Option value="100">All Months</Option>
                </Select>
              </Space>
            </Tooltip>
          </Card>
        </Col>
      </Row>

      {/* CCI coverage for accessed Applications (%) */}
      <Row style={{ margin: "5px", padding: "1px" }}>
        <Col className="gutter-row" span={1}></Col>
        <Col className="gutter-row" span={22}>
          <Card
            title={
              "CCI coverage for accessed known Applications (%) and Unknown Domains"
            }
            size="small"
            headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
            bordered={false}
            style={{ margin: "1px", padding: "1px" }}
          >
            <div>
              <UsedCoverageGraph
                label={trendData["labelDt"]}
                trendLoad={trendLoad}
                chngLoad={chngLoad}
                submit={submit}
                datasets={[
                  datasetUseCov({
                    lineHead: "Apps with CCI (Goal 99%)",
                    data: trendData.cciUseCov["totalCcl"]
                      ? trendData.cciUseCov["totalCcl"].percentage
                      : [],
                    dataLabelAlign: dataLabelMiddle,
                    stackGroup: "Stack 0",
                    color: graphColors["green"],
                    comments: trendData.cciUseCov["totalPresent"]
                      ? trendData.cciUseCov["totalPresent"].map(
                          (item) =>
                            "Total Apps: " +
                            item
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        )
                      : [],
                    originalValue: trendData.cciUseCov["totalCcl"]
                      ? trendData.cciUseCov["totalCcl"].oriVal
                      : [],
                  }),
                  datasetUseCov({
                    lineHead: "Apps without CCI",
                    data: trendData.cciUseCov["totalUnCcl"]
                      ? trendData.cciUseCov["totalUnCcl"].percentage
                      : [],
                    dataLabelAlign: dataLabelMiddle,
                    stackGroup: "Stack 0",
                    color: graphColors["red"],
                    originalValue: trendData.cciUseCov["totalUnCcl"]
                      ? trendData.cciUseCov["totalUnCcl"].oriVal
                      : [],
                  }),
                  datasetUseCov({
                    lineHead: "P1 Apps",
                    data: trendData.cciUseCov["totalP1"]
                      ? trendData.cciUseCov["totalP1"].percentage
                      : [],
                    dataLabelAlign: dataLabelMiddle,
                    stackGroup: "Stack 1",
                    color: graphColors["blue"],
                    comments: trendData.cciUseCov["totalApps"]
                      ? trendData.cciUseCov["totalApps"].map(
                          (item) =>
                            "Total Apps: " +
                            item
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        )
                      : [],
                    originalValue: trendData.cciUseCov["totalP1"]
                      ? trendData.cciUseCov["totalP1"].oriVal
                      : [],
                  }),
                  datasetUseCov({
                    lineHead: "P2 Apps",
                    data: trendData.cciUseCov["totalP2"]
                      ? trendData.cciUseCov["totalP2"].percentage
                      : [],
                    dataLabelAlign: dataLabelTop,
                    stackGroup: "Stack 1",
                    color: graphColors["skyblue"],
                    originalValue: trendData.cciUseCov["totalP2"]
                      ? trendData.cciUseCov["totalP2"].oriVal
                      : [],
                  }),
                  datasetUseCov({
                    lineHead: "Discovery Apps",
                    data: trendData.cciUseCov["totalDiscovery"]
                      ? trendData.cciUseCov["totalDiscovery"].percentage
                      : [],
                    dataLabelAlign: dataLabelTop,
                    stackGroup: "Stack 1",
                    color: graphColors["grey"],
                    originalValue: trendData.cciUseCov["totalDiscovery"]
                      ? trendData.cciUseCov["totalDiscovery"].oriVal
                      : [],
                  }),
                  datasetUseCov({
                    lineHead: "Unknown Domains",
                    data: trendData.cciUseCov["totalUnKnownDomain"]
                      ? trendData.cciUseCov["totalUnKnownDomain"].oriVal
                      : [],
                    dataLabelAlign: dataLabelTopRight,
                    stackGroup: "Stack 2",
                    color: graphColors["orange"],
                    originalValue: trendData.cciUseCov["totalUnKnownDomain"]
                      ? trendData.cciUseCov["totalUnKnownDomain"].oriVal
                      : [],
                    graphType: "line",
                    yAxis: "B",
                  }),
                ]}
                options={gradientUseCovTooltip}
              />
            </div>
          </Card>
        </Col>
      </Row>

      {/* CCI coverage for number of users App access (%) */}
      <Row style={{ margin: "5px", padding: "1px" }}>
        <Col className="gutter-row" span={1}></Col>
        <Col className="gutter-row" span={22}>
          <Card
            title={"CCI coverage for number of users App access (%)"}
            size="small"
            headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
            bordered={false}
            style={{ margin: "1px", padding: "1px" }}
          >
            <div>
              <UsedCoverageGraph
                label={trendData["labelDt"]}
                trendLoad={trendLoad}
                chngLoad={chngLoad}
                submit={submit}
                datasets={[
                  datasetUseCov({
                    lineHead: "Apps Access with CCI",
                    data: trendData.cciUseCov["totalAccessCcl"]
                      ? trendData.cciUseCov["totalAccessCcl"].percentage
                      : [],
                    dataLabelAlign: dataLabelMiddle,
                    stackGroup: "Stack 0",
                    color: graphColors["green"],
                    comments: trendData.cciUseCov["totalAccess"]
                      ? trendData.cciUseCov["totalAccess"].map(
                          (item) =>
                            "Total Access: " +
                            item
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        )
                      : [],
                    originalValue: trendData.cciUseCov["totalAccessCcl"]
                      ? trendData.cciUseCov["totalAccessCcl"].oriVal
                      : [],
                  }),
                  datasetUseCov({
                    lineHead: "Apps Access without CCI",
                    data: trendData.cciUseCov["totalAccessUnCcl"]
                      ? trendData.cciUseCov["totalAccessUnCcl"].percentage
                      : [],
                    dataLabelAlign: dataLabelMiddle,
                    stackGroup: "Stack 0",
                    color: graphColors["red"],
                    originalValue: trendData.cciUseCov["totalAccessUnCcl"]
                      ? trendData.cciUseCov["totalAccessUnCcl"].oriVal
                      : [],
                  }),
                  datasetUseCov({
                    lineHead: "P1 Apps Access (Goal 95%)",
                    data: trendData.cciUseCov["totalAccessP1"]
                      ? trendData.cciUseCov["totalAccessP1"].percentage
                      : [],
                    dataLabelAlign: dataLabelMiddle,
                    stackGroup: "Stack 1",
                    color: graphColors["blue"],
                    comments: trendData.cciUseCov["totalAccess"]
                      ? trendData.cciUseCov["totalAccess"].map(
                          (item) =>
                            "Total Access: " +
                            item
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        )
                      : [],
                    originalValue: trendData.cciUseCov["totalAccessP1"]
                      ? trendData.cciUseCov["totalAccessP1"].oriVal
                      : [],
                  }),
                  datasetUseCov({
                    lineHead: "P2 Apps Access (P1 + P2 Goal 99%)",
                    data: trendData.cciUseCov["totalAccessP2"]
                      ? trendData.cciUseCov["totalAccessP2"].percentage
                      : [],
                    dataLabelAlign: dataLabelTop,
                    stackGroup: "Stack 1",
                    color: graphColors["skyblue"],
                    comments: trendData.cciUseCov["totalAccess"]
                      ? trendData.cciUseCov["totalAccess"].map(
                          (item) =>
                            "Total Access: " +
                            item
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        )
                      : [],
                    originalValue: trendData.cciUseCov["totalAccessP2"]
                      ? trendData.cciUseCov["totalAccessP2"].oriVal
                      : [],
                  }),
                  datasetUseCov({
                    lineHead: "Discovery Apps Access",
                    data: trendData.cciUseCov["totalAccessDiscovery"]
                      ? trendData.cciUseCov["totalAccessDiscovery"].percentage
                      : [],
                    dataLabelAlign: dataLabelTop,
                    stackGroup: "Stack 2",
                    color: graphColors["grey"],
                    comments: trendData.cciUseCov["totalAppAccess"]
                      ? trendData.cciUseCov["totalAppAccess"].map(
                          (item) =>
                            "Total Access: " +
                            item
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        )
                      : [],
                    originalValue: trendData.cciUseCov["totalAccessDiscovery"]
                      ? trendData.cciUseCov["totalAccessDiscovery"].oriVal
                      : [],
                  }),
                ]}
                options={gradientUseCovTooltip}
              />
            </div>
          </Card>
        </Col>
      </Row>

      {/* Inactive and unused Apps in CCI DB */}
      <Row style={{ margin: "5px", padding: "1px" }}>
        <Col className="gutter-row" span={1}></Col>
        <Col className="gutter-row" span={22}>
          <Card
            title={"[Internal Only] Inactive and unused Apps in CCI DB (%)"}
            size="small"
            headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
            bordered={false}
            style={{ margin: "1px", padding: "1px" }}
          >
            <UsedCoverageGraph
              label={trendData.labelMonData}
              trendLoad={trendLoad}
              chngLoad={chngLoad}
              submit={submit}
              datasets={[
                datasetUseCov({
                  lineHead: monthlyDataLabel[0].label,
                  data: trendData.monthlyData.totalDiscovery
                    ? trendData.monthlyData.totalDiscovery.percentage
                    : [],
                  dataLabelAlign: dataLabelMiddle,
                  stackGroup: "Stack 0",
                  color: graphColors.green,
                  comments: trendData.monthlyData?.totalApps
                    ? trendData.monthlyData?.totalApps.map(
                        (item) =>
                          "Total Apps: " +
                          item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      )
                    : [],
                  originalValue: trendData.monthlyData?.totalDiscovery
                    ? trendData.monthlyData?.totalDiscovery.oriVal
                    : [],
                }),
                datasetUseCov({
                  lineHead: monthlyDataLabel[1].label,
                  data: trendData.monthlyData?.totalUnused
                    ? trendData.monthlyData?.totalUnused.percentage
                    : [],
                  dataLabelAlign: dataLabelMiddle,
                  stackGroup: "Stack 0",
                  color: graphColors.blue,
                  comments: trendData.monthlyData?.totalApps
                    ? trendData.monthlyData?.totalApps.map(
                        (item) =>
                          "Total Apps: " +
                          item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      )
                    : [],
                  originalValue: trendData.monthlyData?.totalUnused
                    ? trendData.monthlyData?.totalUnused.oriVal
                    : [],
                }),
                datasetUseCov({
                  lineHead: monthlyDataLabel[2].label,
                  data: trendData.monthlyData?.totalInActiveDomains
                    ? trendData.monthlyData?.totalInActiveDomains.percentage
                    : [],
                  dataLabelAlign: dataLabelMiddle,
                  stackGroup: "Stack 0",
                  color: graphColors.orange,
                  comments: trendData.monthlyData?.totalApps
                    ? trendData.monthlyData?.totalApps.map(
                        (item) =>
                          "Total Apps: " +
                          item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      )
                    : [],
                  originalValue: trendData.monthlyData?.totalInActiveDomains
                    ? trendData.monthlyData?.totalInActiveDomains.oriVal
                    : [],
                }),
                datasetUseCov({
                  lineHead: monthlyDataLabel[3].label,
                  data: trendData.monthlyData?.totalInActiveUnused
                    ? trendData.monthlyData?.totalInActiveUnused.percentage
                    : [],
                  dataLabelAlign: dataLabelMiddle,
                  stackGroup: "Stack 0",
                  color: graphColors.red,
                  comments: trendData.monthlyData?.totalInActiveDomains?.oriVal
                    ? trendData.monthlyData?.totalInActiveDomains.oriVal.map(
                        (item) =>
                          "Total Apps: " +
                          item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      )
                    : [],
                  originalValue: trendData.monthlyData?.totalInActiveUnused
                    ? trendData.monthlyData?.totalInActiveUnused.oriVal
                    : [],
                }),
              ]}
              options={gradientUseCovLegendTooltip}
            />
          </Card>
        </Col>
      </Row>

      {/* Connector coverage for number of users App access (%)
       */}
      <Row style={{ margin: "5px", padding: "1px" }}>
        <Col className="gutter-row" span={1}></Col>
        <Col className="gutter-row" span={22}>
          <Card
            title={"Connector coverage for number of users App access (%)"}
            size="small"
            headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
            bordered={false}
            style={{ margin: "1px", padding: "1px" }}
          >
            <div>
              <UsedCoverageGraph
                label={trendData["labelDt"]}
                trendLoad={trendLoad}
                chngLoad={chngLoad}
                submit={submit}
                datasets={[
                  datasetUseCov({
                    lineHead: "Apps Access with P1 Connector",
                    data: trendData.cciUseCov["totalAccessConP1"]
                      ? trendData.cciUseCov["totalAccessConP1"].percentage
                      : [],
                    dataLabelAlign: dataLabelMiddle,
                    stackGroup: "Stack 0",
                    color: graphColors["green"],
                    comments: trendData.cciUseCov["totalAccess"]
                      ? trendData.cciUseCov["totalAccess"].map(
                          (item) =>
                            "Total Access: " +
                            item
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        )
                      : [],
                    originalValue: trendData.cciUseCov["totalAccessConP1"]
                      ? trendData.cciUseCov["totalAccessConP1"].oriVal
                      : [],
                  }),
                  datasetUseCov({
                    lineHead: "Apps Access with P2 Connector",
                    data: trendData.cciUseCov["totalAccessConP2"]
                      ? trendData.cciUseCov["totalAccessConP2"].percentage
                      : [],
                    dataLabelAlign: dataLabelMiddle,
                    stackGroup: "Stack 0",
                    color: graphColors["blue"],
                    comments: trendData.cciUseCov["totalAccess"]
                      ? trendData.cciUseCov["totalAccess"].map(
                          (item) =>
                            "Total Access: " +
                            item
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        )
                      : [],
                    originalValue: trendData.cciUseCov["totalAccessConP2"]
                      ? trendData.cciUseCov["totalAccessConP2"].oriVal
                      : [],
                  }),
                  datasetUseCov({
                    lineHead: "Apps Access with UC",
                    data: trendData.cciUseCov["totalAccessNoCon"]
                      ? trendData.cciUseCov["totalAccessNoCon"].percentage
                      : [],
                    dataLabelAlign: dataLabelMiddle,
                    stackGroup: "Stack 0",
                    color: graphColors["red"],
                    originalValue: trendData.cciUseCov["totalAccessNoCon"]
                      ? trendData.cciUseCov["totalAccessNoCon"].oriVal
                      : [],
                  }),
                ]}
                options={gradientUseCovTooltip}
              />
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
};

let refTool = null;
const UsedCoverageGraph = (props) => {
  const [graphData, setGraphData] = useState([]);
  const [load, setLoading] = useState(true);
  refTool = useRef();
  useEffect(() => {
    setLoading(true);
    setGraphData({
      label: props.label,
      graphDatasets: props.datasets,
      graphOptions: props.options,
    });
    setLoading(false);
    console.log("hey props ");
  }, [props.chngLoad]);
  return (
    <>
      <div style={{ margin: "5px", padding: "1px" }}>
        {load ? (
          <div>
            <Spin className={styles.spinner} size="small" />
          </div>
        ) : (
          <Card
            size="small"
            headStyle={{ backgroundColor: "#FDEEF4", border: 0 }}
            bordered={false}
          >
            <Bar
              height={100}
              data={{
                labels: graphData["label"],
                datasets: graphData["graphDatasets"],
              }}
              options={graphData["graphOptions"]}
            />
          </Card>
        )}
      </div>
    </>
  );
};

const toolTip = {
  enabled: true,
  mode: "x",
  callbacks: {
    afterFooter: function (tooltipItems, data) {
      if ("comments" in data["datasets"][tooltipItems[0].datasetIndex]) {
        if (
          data["datasets"][tooltipItems[0].datasetIndex]["comments"].length > 0
        ) {
          return data["datasets"][tooltipItems[0].datasetIndex]["comments"][
            tooltipItems[0]["index"]
          ];
        }
      }
      return "";
    },
    label: function (tooltipItems, data) {
      let oriVal = tooltipItems.value;
      if ("originalValue" in data["datasets"][tooltipItems.datasetIndex]) {
        if (
          data["datasets"][tooltipItems.datasetIndex]["originalValue"].length >
          0
        ) {
          oriVal =
            data["datasets"][tooltipItems.datasetIndex]["originalValue"][
              tooltipItems["index"]
            ];
        }
      }
      let label =
        data["datasets"][tooltipItems.datasetIndex]["label"].split("(")[0];
      return (
        label + ": " + oriVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    },
  },
  backgroundColor: "#f5f5f5",
  titleFontColor: "#333",
  bodyFontColor: "#666",
  footerFontColor: "#566573",
  bodySpacing: 4,
  xPadding: 12,
  intersect: 0,
  position: "nearest",
};

const gradientUseCovTooltip = {
  tooltips: toolTip,
  legend: {
    position: "bottom",
  },
  responsive: true,
  interaction: {
    intersect: false,
  },
  scales: {
    yAxes: [
      {
        id: "A",
        position: "left",
      },
      {
        id: "B",
        position: "right",
        display: "auto",
        gridLines: [
          {
            display: false,
          },
        ],
      },
    ],
  },
};

let legendOnHover = false;
const gradientUseCovLegendTooltip = {
  tooltips: toolTip,
  legend: {
    position: "bottom",
    onHover: function (event, legendItem, legend) {
      if (legendOnHover) return;
      legendOnHover = true;
      refTool.current.innerHTML =
        "<span style='font-weight: 500;color:" +
        graphColors[monthlyDataLabel[legendItem.datasetIndex].color] +
        "'>&#9644; </span>" +
        monthlyDataLabel[legendItem.datasetIndex].extra;
      refTool.current.style.left = event.pageX + "px";
      refTool.current.style.top = event.pageY + 10 + "px";
    },
    onLeave: function () {
      legendOnHover = false;
      refTool.current.innerHTML = "";
    },
  },
  responsive: true,
  interaction: {
    intersect: false,
  },
  scales: {
    yAxes: [
      {
        id: "A",
        position: "left",
      },
      {
        id: "B",
        position: "right",
        display: "auto",
        gridLines: [
          {
            display: false,
          },
        ],
      },
    ],
  },
};

const gradientUseCov = {
  responsive: true,
  legend: {
    position: "bottom",
  },
  interaction: {
    intersect: false,
  },
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
    },
  },
};

const datasetUseCov = (graphDataset) => {
  let graphType = graphDataset.graphType ? graphDataset.graphType : "bar";
  let yAxis = graphDataset.yAxis ? graphDataset.yAxis : "";
  return {
    type: graphType,
    yAxisID: yAxis,
    label: graphDataset.lineHead,
    fill: false,
    barPercentage: 1.0,
    categoryPercentage: 0.6,
    backgroundColor: graphDataset.color + ", 0.2)",
    hoverBackgroundColor: graphDataset.color + ", 0.8)",
    borderColor: graphDataset.color + ", 132)",
    borderWidth: graphType == "line" ? 3 : 2,
    borderDash: [],
    borderDashOffset: 0.0,
    data: graphDataset.data,
    datalabels: graphDataset.dataLabelAlign,
    stack: graphDataset.stackGroup,
    comments: "comments" in graphDataset ? graphDataset.comments : [],
    originalValue:
      "originalValue" in graphDataset ? graphDataset.originalValue : [],
  };
};

const dataLabelTop = {
  align: "end",
  color: "black",
};

const dataLabelTopRight = {
  align: "right",
  color: "black",
};
const dataLabelBottom = {
  align: "start",
  color: "black",
};
const dataLabelMiddle = {
  align: "center",
  color: "black",
};

const graphColors = {
  green: "rgba(0, 255, 0",
  red: "rgba(255, 0, 0",
  blue: "rgba(0, 0, 255",
  skyblue: "rgba(0, 204, 255",
  orange: "rgba(245, 126, 32",
  grey: "rgba(128, 128, 128",
};
export default CciAppsUseCov;
